<template>
  <!-- Delivering Widget -->
  <div
    v-if="showDeliveringWidget"
    class="col-sm-12 col-md-12 col-lg-12 nxg-track-wid"
    @click="openTrackingPage"
  >
    <div
      class="flex-column main-confirm-order mb8 pd16r main-order-item"
      :class="[
        isReachedGate && isSgFulfilled ? 'reached-gate-sg' : null,
        showAnimationClass ? 'animate-order' : ''
      ]"
    >
      <div class="reached-sg-wrapper" v-if="isReachedGate && isSgFulfilled">
        <VueLottiePlayer
          name="delivery-gurantee"
          width="170px"
          height="170px"
          :autoplay="true"
          :path="staticImgBaseUrl + '/images/animation/rQKLp7k1UR.json'"
        />
      </div>
      <div
        class="celebration-conffeti"
        v-if="isReachedGate && isSgFulfilled && showBouquetCelebration"
      >
        <VueLottiePlayer
          name="ConfettiCelebration"
          width="100%"
          height="100%"
          :autoplay="true"
          :loop="false"
          :path="staticImgBaseUrl + '/images/animation/2sSbtwRZ3e.json'"
        />
      </div>
      <div class="flex-row jcsb align-items-center">
        <span class="fs-12 color-slaty" v-html="itemSummaryText"></span>
        <img src="../../../default/images/global/nxg-expand.svg" class="" />
      </div>
      <div class="flex-row jcsb" v-if="!isAdvOrderValid">
        <div
          class="flex-column pdt12r gap8 mr8 align-items-start justify-content-around"
        >
          <img src="../../../default/images/global/divider.svg" class="" />
          <div
            class="disp-col-inline gap4 mt4"
            :class="[isReachedGate && !isSgFulfilled ? 'hide' : '']"
          >
            <div
              class="upercase fs-12 flex-row align-items-center"
              :class="[
                delayLevel == 0
                  ? 'status-txt'
                  : delayLevel == 1
                  ? 'delay-label'
                  : 'extreme-delay'
              ]"
              v-if="!(isReachedGate && !isSgFulfilled)"
            >
              <div
                v-if="isReachedGate && isSgFulfilled"
                class="bolt-lottie-wrapper"
              >
                <VueLottiePlayer
                  name="bolt-green"
                  width="22.4"
                  height="22.4"
                  :autoplay="true"
                  :loop="true"
                  :path="staticImgBaseUrl + '/images/animation/TIabIzKCpR.json'"
                />
              </div>
              <span class="fw-600">{{ timeStatusLabel }}</span>
            </div>
            <span
              class="flex-row align-items-center"
              v-if="!isReachedGate && this.deliveryType == 'D'"
              ><span class="fs-12"
                >{{ moduleProps?.arriving_in_txt }}&nbsp;</span
              ><span class="fw-700 fs-14 order-eta">{{ eta }} mins</span></span
            >
            <span class="flex-row align-items-center" v-if="isDitaValid"
              ><span class="fs-12">{{ ditaStatusMsg }}&nbsp;</span
              ><span class="fw-700 fs-14 order-eta">{{ eta }} mins</span></span
            >
          </div>
          <span class="fw-600 fs-16 p mt4 tl" v-html="orderStatusMsg"></span>
          <span
            class="fs-12 color-slaty reached-gate-txt"
            v-if="isReachedGate"
            >{{ reachedGateText }}</span
          >
        </div>
          <img
            :src="orderStatusIcon"
            class="order-track-status-img"
            v-if="orderStatusIcon"
          />
          </div>
      <div class="progress mt12" v-if="!isReachedGate && !isAdvOrderValid">
        <div
          class="progress-value"
          :style="{ width: progress + '%' }"
          :class="[progressTransistion ? 'show-transition' : '']"
        ></div>
      </div>
      <nxg-adv-widget
        v-if="isAdvOrderValid"
        :orderSummary="orderSummary"
        :currentIndex="currentIndex"
        :isStickyBottom="isStickyBottom"
        :moduleProps="moduleProps"
        :totalOrderCount="totalOrderCount"
        :isNgAdvanceOrder="isNgAdvanceOrder"
      />
    </div>

  </div>
  <!-- Delivering Widget -->

  <!-- Delivered Widget -->
  <div
    v-if="showDeliveredWidget || showDitaWidget"
    class="col-sm-12 col-md-12 col-lg-12 nxg-track-wid nxg-track-delivered"
    :class="[showDitaWidget && ditaNotReceived ? 'hide' : '']"
  >
    <div
      class="flex-column main-confirm-order mb8 main-order-item"
      :class="[isSgFulfilled ? 'delivered-sg' : 'delivered-non-sg']"
    >
      <div
        class="celebration-conffeti"
        v-if="isSgFulfilled && showBouquetCelebration"
      >
        <VueLottiePlayer
          name="ConfettiCelebration"
          width="100%"
          height="100%"
          :autoplay="true"
          :loop="true"
          :path="staticImgBaseUrl + '/images/animation/2sSbtwRZ3e.json'"
        />
      </div>
      <div
        class="up-delivered-wid flex-row justify-space-between"
        :class="[isSgFulfilled ? 'sgDelivered' : 'nonSgDelivered']"
      >
        <div class="gaurantee-lottie-wrapper" v-if="isSgFulfilled">
          <VueLottiePlayer
            name="delivery-gurantee"
            width="120px"
            height="120px"
            :autoplay="true"
            :path="staticImgBaseUrl + '/images/animation/rQKLp7k1UR.json'"
          />
        </div>
        <img v-else :src="orderDeliveredIcon" class="non-sg-del" />
        <div class="flex-column align-items-start gap4">
          <span class="lh24 fs-16 fw-600" v-html="orderDeliveredMsg"></span>
          <span class="lh18">{{ moduleProps.delivered_sub_txt }}</span>
        </div>
        <img src="../../../default/images/global/nxg-expand.svg" class="" />
      </div>
      <div
        class="flex-row gap8 pd16r del-down-block align-items-center"
        :class="[showDitaWidget && ditaNotReceived ? 'hide' : '']"
      >
        <VueLottiePlayer
          name="GotItClick"
          width="40px"
          height="40px"
          :autoplay="true"
          :path="staticImgBaseUrl + '/images/animation/gSKp9V0DCN.json'"
          v-if="showCheckAnimation"
        />
        <div class="tl color-slaty delivered-msg">
          {{
            showDitaWidget
              ? moduleProps[`${deliveryTxt}_msg`]
              : moduleProps.delivered_msg
          }}
        </div>
        <div class="call-btns">
          <button
            class="line-btn dark mr12 rider-btn ripple"
            @click="handleGotItClick"
             :class="[showNoCheckAnimation ? 'disable-csat-btn' : showCheckAnimation ? 'got-it-btn' : '']"
          >
            <span :class="[showCheckAnimation ? 'hide' : '']">{{
              showDitaWidget
                ? moduleProps[`${deliveryTxt}_yes_btn_txt`]
                : moduleProps.yes_btn_txt
            }}</span>
            <VueLottiePlayer
              name="GotItClick"
              height="35px"
              :autoplay="true"
              :path="staticImgBaseUrl + '/images/animation/gSKp9V0DCN.json'"
              v-if="showCheckAnimation"
            />
          </button>
          <button class="line-btn dark rider-btn ripple" @click="callRider"  :class="[showNoCheckAnimation ? 'no-dita-clicked' : showCheckAnimation ? 'disable-csat-btn' : '']">
            <span :class="[showNoCheckAnimation ? 'hide' : '']">
              {{
                showDitaWidget
                  ? moduleProps[`${deliveryTxt}_no_btn_txt`]
                  : moduleProps.no_btn_txt
              }}</span
            >
            <VueLottiePlayer
              name="GotItClick"
              height="35px"
              :autoplay="true"
              path="https://lottie.host/150c5d31-774f-4fac-bfbc-2fcbabcb028e/gSKp9V0DCN.json"
               v-if="showNoCheckAnimation"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="dita-notready-label mt16 ml8 mr8"
    v-if="showDitaWidget && ditaNotReceived"
  >
    <span class="fw-700 fs-14">Our Apologies</span>
    <span class="fs-11 fw-400"
      >We’re committed to a better experience next time.</span
    >
  </div>
  <!-- Delivered Widget -->

  <!-- Bottom Sticky Widget -->
  <div
    v-show="isStickyBottom"
    @click="openTrackingPage"
    class="bottom-wid-wrapper"
  >
    <div class="reached-sg-wrapper-btm" v-if="isReachedGate && isSgFulfilled">
      <VueLottiePlayer
        name="delivery-gurantee"
        width="120px"
        height="120px"
        :autoplay="true"
        :path="staticImgBaseUrl + '/images/animation/rQKLp7k1UR.json'"
      />
    </div>
    <div class="flex-row jcsb align-items-start" v-if="!isAdvOrderValid">
      <div
        class="flex-column gap8 mr8 align-items-start justify-content-around" v-if="!isAdvOrderValid"
      >
        <div class="disp-col-inline gap4">
          <div
            class="upercase fs-12 flex-row align-items-center"
            :class="[
              delayLevel == 0
                ? 'status-txt'
                : delayLevel == 1
                ? 'delay-label'
                : 'extreme-delay'
            ]"
            v-if="!(isReachedGate && !isSgFulfilled)"
          >
            <div>
              <VueLottiePlayer
                name="bolt-green"
                width="22.4"
                height="22.4"
                :autoplay="true"
                :loop="true"
                :path="staticImgBaseUrl + '/images/animation/TIabIzKCpR.json'"
                v-if="isReachedGate && isSgFulfilled"
              />
            </div>
            <span class="fw-600">{{ timeStatusLabel }}</span>
          </div>
          <span class="flex-row align-items-center" v-if="!isReachedGate"
            ><span class="fs-12">{{ moduleProps?.arriving_in_txt }}&nbsp;</span
            ><span class="fw-700 fs-14 order-eta">{{ eta }} mins</span></span
          >
        </div>
        <span class="fw-600 fs-16 p" v-html="orderStatusMsg"></span>
        <span class="fs-12 color-slaty reached-gate-txt" v-if="isReachedGate">{{
          reachedGateText
        }}</span>
      </div>
       <span class="fs-12 color-slaty" v-html="itemSummaryText" v-if="isAdvOrderValid"></span>
      <img src="../../../default/images/global/nxg-expand.svg" class="" />
    </div>
    <div class="progress mt12" v-if="!isReachedGate && !isAdvOrderValid">
      <div
        class="progress-value"
        :style="{ width: progress + '%' }"
        :class="[progressTransistion ? 'show-transition' : '']"
      ></div>
    </div>
    <nxg-adv-widget
      v-if="isAdvOrderValid"
      :orderSummary="orderSummary"
      :currentIndex="currentIndex"
      :isStickyBottom="isStickyBottom"
      :moduleProps="moduleProps"
      :totalOrderCount="totalOrderCount"
      :isNgAdvanceOrder="isNgAdvanceOrder"
    />
    
  </div>
  <!-- Bottom Sticky Widget -->

  <!-- Shimmer Widget-->
  <div
    class="col-sm-12 col-md-12 col-lg-12 nxg-track-wid"
    v-if="showShimmer && !isStickyBottom"
  >
    <div class="home-track-shimmer">
      <img
        src="../../../default/images/global/home-track-widget-shimmer.svg"
        class="shimmer-image"
      />
      <div class="shimmer-overlay"></div>
    </div>
  </div>

  <!-- Shimmer Widget -->

  <!-- Failure/ Cancel Widget -->
  <div
    v-if="(isFailed || isCancelled) && !isStickyBottom"
    class="col-sm-12 col-md-12 col-lg-12 nxg-track-wid"
  >
    <div
      class="main-confirm-order mb16 flex-column no-border main-order-item min-height-50 fail-cancel-wrapper"
    >
      <div
        class="flex-column align-items-start gap4 pd16r failedWid"
        :class="[!refundAmt ? 'bottom-red-btm' : '']"
      >
        <span class="lh24 fs-18 fw-700">{{ failedCancelledTitle }}</span>
        <span class="lh18 fs-14 color-slaty">{{
          failedCancelledSubtitle
        }}</span>
      </div>
      <div class="flex-column pd12 fail-cancel-btm" v-if="refundAmt">
        <span
          class="fs-14 lh18 fw-500 tl"
          :class="[!refundAmt ? 'invisible' : '']"
          v-html="isFailed ? failedRefundTitle : cancelRefundMsg"
        ></span>
        <span
          v-if="isFailed"
          class="fs-12 lh16 color-slaty tl"
          :class="[!refundAmt ? 'invisible' : '']"
          >{{ failedRefundSubtitle }}</span
        >
      </div>
    </div>
  </div>
  <!-- Failure Widget -->
</template>

<script>
import localStorageFunc from '../helpers/localStorageFunc'
import utility from '../helpers/utility'
import {
  ORDER_TYPE,
  ORDER_STATUS_DEL,
  DELIVERY_TYPE
} from '../helpers/paymentConstants'
import { keyMapsAction } from '../helpers/storeKeys'
import {staticImgBaseUrl} from '../config/apiEndpoints'
import NxgAdvWidget from './NxgAdvWidget.vue'
import { CURRENCY_SYMBOL } from "../helpers/paymentConstants";


export default {
  name: 'NxgTrackWidget',
  setup () {
    return {}
  },
  components: {
    NxgAdvWidget
  },
  props: [
    'orderSummary',
    'currentIndex',
    'isStickyBottom',
    'moduleProps',
    'totalOrderCount',
    'isNgAdvanceOrder'
  ],
  data () {
    return {
      showCheckAnimation: true,
      hideReceiveOrderView: false,
      showAnimationClass: false,
      showBouquetCelebration: false,
      hasShownBouquetCelebration: false,
      currentOrderData: [],
      ditaNotReceived: false,
      staticImgBaseUrl: staticImgBaseUrl,
      showNoCheckAnimation: false,
      currencySymbol: CURRENCY_SYMBOL,
    }
  },
  mounted () {},
  watch: {
    orderStatusCode (newVal) {
      if (
        newVal === 11 ||
        (newVal == 9 && this.isSgFulfilled && !this.hasShownBouquetCelebration)
      ) {
        this.showBouquetCelebration = true
        this.hasShownBouquetCelebration = true

        setTimeout(() => {
          this.showBouquetCelebration = false
        }, 10000)
      }
    },
    currentIndex () {
      this.hasShownBouquetCelebration = false
    }
  },
  computed: {
    orderData () {
      return this.$store.state.NxgTrackOrder?.allOrderData?.[this.currentIndex]
    },
    isDelivered () {
      return this.orderData?.orderStatusCode == 9
    },
    progress () {
      if (
        this.deliveryType == ORDER_TYPE.PICKUP ||
        this.deliveryType == ORDER_TYPE.DINEIN
      ) {
        return this.orderData?.etaWidget?.eta?.progress || 4
      }
      return this.orderData?.etaWidget?.eta?.progress || 0
    },
    eta () {
      return this.orderData?.etaWidget?.eta?.eta
    },
    timeStatusLabel () {
      if (this.isReachedGate) return 'REACHED BEFORE-TIME'
      return this.orderData?.etaWidget?.eta?.timeStatusValue || ''
    },
    orderStatusMsg () {
      if (this.isReachedGate && this.deliveryType == ORDER_TYPE.DELIVERY) {
        const reachedOnTime = this.moduleProps.arrived_before_txt
        const reachedTime = this.orderData?.reachedGateIn
        let reachedWithTime = reachedOnTime.replace(
          'XX',
          `<span class="fw-800">${reachedTime} mins</span>`
        )
        const reachedDelay = this.moduleProps.arrived_txt
        if (this.isSgFulfilled) return reachedWithTime
        else return reachedDelay
      }

      return (
        this.orderData?.etaWidget?.orderTrackingMessages?.statusMessage || ''
      )
    },
    arrivalTimeStatus () {
      return this.orderData?.etaWidget?.eta?.timeStatus || ''
    },
    delayLevel () {
      if (this.arrivalTimeStatus === 'DELAYED') return 2
      if (this.arrivalTimeStatus === 'SLIGHT_DELAY') return 1
      return 0
    },
    orderStatusCode () {
      const statusCode = this.orderData?.orderStatusCode || 0

      return statusCode
    },
    orderStatusIcon () {
      if (this.isAdvOrderValid) return require('../../../default/images/global/clock_adv.svg')
      else if (this.orderStatusCode == 1) return this.moduleProps.preparing_icon
      else if (this.orderStatusCode == 2) return this.moduleProps.baking_icon
      else if (
        this.orderStatusCode <= 4 &&
        this.deliveryType === ORDER_TYPE.DELIVERY
      )
        return require('../../../default/images/global/nxg-track-map.svg')
      else if (this.orderStatusCode == 11) {
        if (this.isSgFulfilled) {
          return ''
        } else {
          return this.moduleProps.reached_gate_icon
        }
      } else if (
        this.orderStatusCode === 9 &&
        this.deliveryType !== ORDER_TYPE.DELIVERY
      ) {
        return this.moduleProps.picked_up_img
      } else {
        return this.moduleProps.confirmed_icon
      }
    },
    orderDeliveredIcon () {
      return this.deliveryType == ORDER_TYPE.DELIVERY
        ? this.moduleProps.delivered_icon
        : this.moduleProps.picked_up_img
    },
    orderDeliveredMsg () {
      if (this.deliveryType == ORDER_TYPE.DELIVERY) {
        if (this.isSgFulfilled)
          return `${this.moduleProps.delivered_before_title} <span class="del-green-msg"> in ${this.orderData?.reachedGateIn} mins!</span>`
        else return this.moduleProps.delivered_title
      } else {
        return this.moduleProps[`${this.deliveryTxt}_delivered_title`]
      }
    },
    isSgFulfilled () {
      return (
        (this.orderData?.sgFulfilled &&
          this.deliveryType == ORDER_TYPE.DELIVERY) ||
        false
      )
    },
    isReachedGate () {
      return (
        this.orderStatusCode === 11 && this.deliveryType == ORDER_TYPE.DELIVERY
      )
    },
    isFailed () {
      return (
        this.orderData?.orderStatus === 'FAILED' ||
        this.orderData?.orderStatus === 'FAILURE'
      )
    },
    isCancelled () {
      return (
        this.orderData?.orderStatus === 'CANCELLED' ||
        this.orderSummary?.orderCurrentState == 5 ||
        this.orderData?.orderStatusCode == 5
      )
    },
    reachedGateText () {
      if (this.isSgFulfilled) return this.moduleProps.arrived_before_bottom_txt
      else return this.moduleProps.arrived_bottom_txt
    },
    itemCount () {
      const items = this.orderSummary?.items || []
      return items.length > 1 ? `${items.length} items` : `${items.length} item`
    },
    totalPrice () {
      return this.orderSummary?.finalPrice || 0
    },
    failedCancelledTitle () {
      if (this.isFailed) return `${this.moduleProps.failed_title} 🚫`
      else return this.moduleProps.canceled_title
    },
    failedCancelledSubtitle () {
      if (this.isFailed) return this.moduleProps.failed_message
      else return 'due to excess demand at the store!'
    },
    showShimmer () {
      // return true;
      const showTrackingShimmer =
        this.$store.state.NxgTrackOrder?.showTrackingShimmer
      if (showTrackingShimmer === false) {
        this.showAnimationClass = true
        setTimeout(() => {
          this.showAnimationClass = false
        }, 2000)
      }
      return showTrackingShimmer || false
    },
    refundAmt () {
      const paymentResponse = this.orderSummary?.paymentResponse || {}
      console.log('cash' in paymentResponse)
      if (this.isCancelled && !('cash' in paymentResponse)) {
        const paymentSummaryItems =
          this.orderSummary?.paymentSummary?.paymentSummaryItem || []
        const grandTotal = paymentSummaryItems.find(
          item => item.key == 'grand_total'
        )
        return grandTotal?.value || 0
      }
      return localStorageFunc.getSgRefundAmt()
    },
    failedRefundTitle () {
      let refundTemplate =
        this.moduleProps?.failed_refund_message1 ||
        '#$% Refund will be initiated soon'
      const refundMsg = refundTemplate.replace(
        '#$%',
        `<span>${this.currencySymbol}</span>${this.refundAmt}`
      )
      return refundMsg
    },
    cancelRefundMsg () {
      let refundTemplate =
        this.moduleProps?.canceled_refund_message ||
        'Refund worth #$% will be credited to your source account within 5-7 working days'
      const refundAmt = this.refundAmt
      const refundMsg = refundTemplate.replace(
        '#$%',
        `<span>${this.currencySymbol}</span>${refundAmt}`
      )
      return refundMsg
    },
    failedRefundSubtitle () {
      return (
        this.moduleProps?.failed_refund_message2 ||
        'Amount will be credited in 5-7 working days'
      )
    },
    showDeliveredWidget () {
      return (
        !this.isFailed &&
        !this.isCancelled &&
        this.isDelivered &&
        !this.isStickyBottom &&
        !this.showShimmer &&
        !this.hideReceiveOrderView
      )
    },
    showDitaWidget () {
      return (
        !this.isFailed &&
        !this.isCancelled &&
        this.showDitaDelivered &&
        !this.isStickyBottom &&
        !this.showShimmer &&
        !this.hideReceiveOrderView
      )
    },
    showDeliveringWidget () {
      return (
        !this.isDelivered &&
        !this.isFailed &&
        !this.isCancelled &&
        !this.showShimmer &&
        !this.isStickyBottom &&
        this.moduleProps
      )
    },
    itemSummaryText () {
      return this.isAdvOrderValid ? `${this.itemCount} •  <span>${ this.currencySymbol }</span>${this.totalPrice}`:`Order #${this.orderSummary?.store?.orderId} • ${this.itemCount} •  <span>${ this.currencySymbol }</span>${this.totalPrice}`
    },
    isOrderTerminal () {
      return this.isFailed || this.isCancelled || this.isDelivered
    },
    ditaStatusMsg () {
      if (this.isDitaValid && this.orderStatusCode < 4) {
        const reachedOnTime =
          this.moduleProps[`${this.deliveryTxt}_to_be_ready_in_txt`]
        const reachedDelay =
          this.moduleProps[`${this.deliveryTxt}_ready_in_txt`]
        if (this.orderStatusCode < 4) return reachedOnTime
        else return reachedDelay
      }
      return ''
    },
    isDitaValid () {
      const deliveryType =
        this.orderSummary?.deliveryOrderType?.deliveryTypeCode || ''
      return deliveryType !== ORDER_TYPE.DELIVERY
    },
    deliveryType () {
      return this.orderSummary?.deliveryOrderType?.deliveryTypeCode || ''
    },
    showDitaDelivered () {
      return (
        this.orderStatusCode === 9 && this.deliveryType !== ORDER_TYPE.DELIVERY
      )
    },
    statusMessage () {
      if (this.isPickedUp || this.isReachedGate || this.isOutForDelivery)
        return tntLang.readyIn
      else if (this.isDelivered) return tntLang.pickedUpIn
      else return tntLang.toBeReadyIn
    },
    isPickedUp () {
      return this.orderStatusCode == 7
    },
    isReachedGate () {
      return this.orderStatusCode == 11
    },
    isOutForDelivery () {
      return this.orderStatusCode == 4
    },
    deliveryTxt () {
      console.log(
        this.showDitaWidget,
        '**********DELIVERY_TYPE[this.deliveryType]',
        DELIVERY_TYPE[this.deliveryType]
      )

      return DELIVERY_TYPE[this.deliveryType]
    },
    progressTransistion () {
      if (this.$store.state.NxgTrackOrder?.allOrderData?.[this.currentIndex]) {
        const order =
          this.$store.state.NxgTrackOrder?.allOrderData?.[this.currentIndex]
        if (this.currentOrderData.length) {
          const value = this.currentOrderData.filter(
            val => val === order.orderId
          )
          if (value.length > 0) return false
          else {
            this.currentOrderData.push(order.orderId)
            return true
          }
        } else {
          this.currentOrderData.push(order.orderId)
          return true
        }
      }
    },
    isAdvOrderValid() {
      const statusCode =
        this.orderStatusCode || this.orderSummary?.orderCurrentState || 0
      return (
        this.isNgAdvanceOrder &&
        this.orderSummary?.advanceOrder &&
        statusCode == 1
      )
    }
  },
  methods: {
    handleGotItClick (event) {
      event.stopPropagation() // Adding this so that wrapper's onclick doesn't get triggered
      if (this.showDitaWidget) {
        this.callDitaApi(true)
      } else {
        utility.fireHomeTrackAmplitudeEvent(
          'order_tracking_widget_feedback_clicked',
          'order delivery feedback',
          this.orderData,
          this.orderSummary,
          this.currentIndex,
          'yes got it',
          this.totalOrderCount
        )
      }
      const delDownBlock = event.currentTarget.closest('.del-down-block')
      if (delDownBlock && !this.showDitaWidget) {
        const child1 = delDownBlock.querySelector('.call-btns')
        const child2 = delDownBlock.querySelector('.tl.color-slaty')
        delDownBlock.classList.add('clicked')
        if (child1) child1.classList.add('hide')
        if (child2) child2.classList.add('hide')
      }

      setTimeout(() => {
        this.showCheckAnimation = true
      }, 300)
      setTimeout(() => {
        this.hideReceiveOrderView = true
        // logic to remove widget
        if (this.currentIndex > 0) {
          this.$emit('update-index', this.currentIndex - 1, 0)
        } else {
          this.$emit('update-index', 1)
        }
      }, 3000)
    },
    callRider () {
      if (this.showDitaWidget) {
        this.callDitaApi(false)
        setTimeout(() => {
        this.showNoCheckAnimation = true
      }, 300)
      setTimeout(()=>{
        this.ditaNotReceived = true
      },3000)
      } else {
        utility.fireHomeTrackAmplitudeEvent(
          'order_tracking_widget_feedback_clicked',
          'order delivery feedback',
          this.orderData,
          this.orderSummary,
          this.currentIndex,
          'no, call rider',
          this.totalOrderCount
        )

        const riderContactNumber =
          this.orderData?.orderTracker?.riderInfo?.riderContactNumber || ''
        window.location.href = `tel:${riderContactNumber}`
      }
    },
    openTrackingPage () {
      if (this.ditaNotReceived) {
        return
      }
      utility.fireHomeTrackAmplitudeEvent(
        'order_tracking_widget_clicked',
        'Active Order widget clicked',
        this.orderData,
        this.orderSummary,
        this.currentIndex,
        '',
        this.totalOrderCount
      )
      // save orderId in local Storage
      localStorage.setItem('ORDER_TRACKING_ID', this.orderSummary.id)

      const deliveryType =
        this.orderSummary?.deliveryOrderType?.deliveryTypeCode || ''
      if (
        deliveryType === ORDER_TYPE.TAKEAWAY ||
        deliveryType === ORDER_TYPE.DINEIN ||
        deliveryType === ORDER_TYPE.PICKUP ||
        deliveryType === ORDER_TYPE.DELIVERY
      ) {
        window.location.href = utility.getNextGenTntUrl()
      } else {
        const thankYouUrl = `/thankYou?transactionId=${this.orderSummary.orderTransactionId}`
        window.location.replace(thankYouUrl)
      }
    },
    callDitaApi (isPickedUp) {
      const clickMsg = isPickedUp
        ? 'order_picked_up_widget yes clicked'
        : 'order_picked_up_widget no clicked'
      utility.fireHomeTrackAmplitudeEvent(
        'order_tracking_widget_clicked',
        clickMsg,
        this.orderData,
        this.orderSummary,
        this.currentIndex,
        '',
        this.totalOrderCount
      )
      const orderId = this.orderSummary?.orderId
      this.$store.dispatch(keyMapsAction.DITA_PICK_USER_ACTION, {
        orderId: orderId,
        pickedUp: isPickedUp
      })
    }
  }
}
</script>
